import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPuppetComponent } from './simple-icons-puppet.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPuppetComponent ],
    exports:      [ SimpleIconsPuppetComponent ],
    bootstrap:    []
})
export class SimpleIconsPuppetModule {}
